import thumbsUpGreen from 'img/thumbs-up-green.svg'
import React from 'react'

export const EmptySlide = ({ isCurrent, isApproved }) => {
	return (
		<div
			className={'empty-slide ' + (isCurrent ? 'current' : '')}
		>
			<div className="empty-slide-content">
				<div className="empty-slide-content-icon">
					{isApproved ? <img src={thumbsUpGreen} alt="thumbs up" /> : null}
				</div>
			</div>
		</div>
	)
}